import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ReloadIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.86477 2.85989C5.68959 3.82834 3.93134 5.54115 2.90628 7.69023C2.05754 9.46967 1.75757 11.4515 2.02931 13.3862C2.1101 13.9614 2.71451 14.2825 3.26592 14.1001C3.75693 13.9376 4.04393 13.425 3.98472 12.9112C3.81359 11.4263 4.06121 9.91453 4.71146 8.55126C5.5315 6.83199 6.9381 5.46174 8.67825 4.68698C10.4184 3.91222 12.3779 3.78379 14.2043 4.32479C14.7152 4.47612 15.2094 4.67552 15.6853 4.9153L14.724 6.09605C14.0604 6.91121 14.6912 8.12515 15.7397 8.05065L19.7767 7.76381C20.0445 7.74478 20.2935 7.6188 20.4675 7.41425C20.6415 7.20969 20.7259 6.94374 20.7017 6.67629L20.3354 2.62386C20.2404 1.57325 18.9334 1.1476 18.238 1.94077L17.0023 3.34999C16.3048 2.96284 15.5603 2.64057 14.7723 2.40715C12.4893 1.7309 10.04 1.89144 7.86477 2.85989Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.1374 21.1404C18.3125 20.1719 20.0708 18.4591 21.0958 16.31C21.9448 14.5301 22.2447 12.5477 21.9726 10.6126C21.8917 10.0375 21.2874 9.71637 20.736 9.89883C20.245 10.0613 19.958 10.574 20.0173 11.0878C20.1887 12.5731 19.9411 14.0854 19.2907 15.449C18.4706 17.1683 17.064 18.5385 15.3239 19.3133C13.5837 20.0881 11.6243 20.2165 9.79787 19.6755C9.28697 19.5242 8.79274 19.3248 8.31684 19.085L9.27811 17.9042C9.94175 17.0891 9.31097 15.8751 8.26247 15.9496L4.22546 16.2365C3.95758 16.2555 3.70862 16.3815 3.53462 16.586C3.36062 16.7906 3.27621 17.0565 3.30039 17.324L3.66676 21.3764C3.76175 22.427 5.06869 22.8527 5.76416 22.0595L6.99981 20.6503C7.69732 21.0374 8.44182 21.3597 9.22984 21.5931C11.5128 22.2694 13.9622 22.1088 16.1374 21.1404Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ReloadIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ReloadIcon;
